import { IGeo } from '../../../types/offer';

export const getRegionId = (geo: IGeo) => geo && geo.address && geo.address[0] && geo.address[0].id;
